import $ from 'jquery';
import { Component } from 'react';
import WidgetContainer from 'legacy/javascripts/components/widget_container.es6.jsx';
import StellaError from 'legacy/javascripts/components/stella_error.es6.jsx';
import StellaLoading from 'legacy/javascripts/components/stella_loading.es6.jsx';
import Headline from 'legacy/javascripts/components/headline.es6.jsx';
import ActionsAndKudos from 'actions_and_kudos/containers/actions_and_kudos';
import { RBAC_PRODUCT_AREAS } from 'common/constants/rbacProductAreas';

import widgets from 'legacy/javascripts/components/widgets';
import { shortUsaDateFormat } from 'common/utils/date';

class AgentTrends extends Component {
  constructor(props) {
    super();
    this.state = {
      loading: true,
      isModalOpen: false,
      solicitations: {},
      loadingSolicitations: false,
      error: false,
      show_coaching_notes_widget: false,
    };
    this.handleFilter = this.handleFilter.bind(this);
    this.handleChartFilter = this.handleChartFilter.bind(this);
    this.configureChart();
    this.closeModal = this.closeModal.bind(this);
    this.handleModalClick = this.handleModalClick.bind(this);
    this.paginate = this.paginate.bind(this);
    this.addQueryParams = this.addQueryParams.bind(this);
  }

  refresh() {
    this.setState({ loading: true });
    return $.ajax({
      url: `${window.location.pathname}${window.location.search}`,
      dataType: 'json',
      cache: false,
      success: function (data) {
        data.loading = false;
        this.setState({
          ...data,
          filters: {
            ...data.filters,
            product_area: RBAC_PRODUCT_AREAS.FEEDBACK,
            solicitation_reporting_timestamp:
              DateRangeQueryString.dateRange().solicitation_reporting_timestamp,
          },
        });
      }.bind(this),
      error: function () {
        this.setState({ error: true, loading: false });
      }.bind(this),
    });
  }

  paginate(pageNumber) {
    this.fetchSolicitations({
      ...this.state.solicitationFilters,
      ...this.state.filters,
      page: pageNumber,
    });
  }

  handleChartFilter(data) {
    let { filters, mixpanelId } = data;
    data.chart = mixpanelId.replace(/([A-Z])/g, function ($1) {
      return ' ' + $1.toLowerCase();
    });
    delete data.mixpanelId;

    this.setState({ solicitationFilters: filters });
    let params = { ...this.state.filters, ...filters, _t: Date.now() };

    setTimeout(() => {
      window.ReactInterop.setModal.publish(true);
      window.ReactInterop.cancelPrevious.publish();
      const filterParams = $.param(params);
      window.store &&
        window.store.dispatch({
          type: 'DETERMINED_SERIALIZED_SOLICITATION_STREAM_FILTERS',
          value: { serializedFilters: filterParams },
        });
      window.ReactInterop.solicitationsFetch.publish(filterParams);
    }, 0);
  }

  fetchSolicitations(params) {
    this.setState({ loadingSolicitations: true });
    $.ajax({
      url: `${window.location.pathname}/solicitations?${$.param(params)}`,
      dataType: 'json',
      success: function (data) {
        $('body').css('overflow', 'hidden');
        this.setState({
          isModalOpen: true,
          loadingSolicitations: false,
          solicitations: data,
        });
      }.bind(this),
      error: function () {
        this.setState({ error: true, loadingSolicitations: false });
      }.bind(this),
    });
  }

  handleModalClick(e) {
    let modal = document.querySelector('.stella-modal');
    if (modal && !modal.contains(e.target) && this.state.isModalOpen) {
      this.closeModal();
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.handleModalClick);
    this.refresh().done(() => {
      this.addQueryParams();
    });
  }

  displayWidgets() {
    let formattedWidgets = [];
    let columns = 2;
    for (let i = 0; i < this.state.dynamic_widgets.length; i += 2) {
      let nextIdx = i + 1;
      let { label, klass, data } = this.state.dynamic_widgets[i];
      if (nextIdx !== this.state.dynamic_widgets.length) {
        let {
          label: nextLabel,
          klass: nextKlass,
          data: nextData,
        } = this.state.dynamic_widgets[nextIdx];

        formattedWidgets.push(
          <div key={`row-${i}`} className="row trend-row">
            <div key={`col-${i}`} className="col-md-6 trend-chart-wrapper">
              <WidgetContainer
                title={label}
                data={data}
                widget={widgets[klass]}
                key={i}
                chartHandler={this.handleChartFilter}
              />
            </div>
            <div
              key={`col-${nextIdx}`}
              className="col-md-6 trend-chart-wrapper"
            >
              <WidgetContainer
                title={nextLabel}
                data={nextData}
                widget={widgets[nextKlass]}
                chartHandler={this.handleChartFilter}
                key={nextIdx}
              />
            </div>
          </div>,
        );
        continue;
      }
      formattedWidgets.push(
        <div key={`row-${i}`} className="row trend-row">
          <div key={`col-${i}`} className="col-md-6 trend-chart-wrapper">
            <WidgetContainer
              title={label}
              data={data}
              widget={widgets[klass]}
              key={i}
              chartHandler={this.handleChartFilter}
            />
          </div>
        </div>,
      );
    }
    return formattedWidgets;
  }

  addQueryParams(filters = null) {
    this.setState({ filters: { ...this.state.filters, ...filters } }, () => {
      window.history.replaceState(
        {},
        '',
        window.location.pathname +
          '?' +
          decodeURIComponent($.param(this.state.filters)),
      );
    });
  }

  handleFilter(e, data) {
    let field;
    let filters;
    const targetName = e.target.name;
    if (targetName === 'daterange') {
      field = targetName;
      filters = {
        start_date: data.startDate.toFormat(shortUsaDateFormat),
        end_date: data.endDate.toFormat(shortUsaDateFormat),
        solicitation_reporting_timestamp: data.timestamp,
      };
    } else {
      const value = data ? parseInt(data.id) : e.target.value;
      field = e.target.id;

      if (this.state.filters[field] !== value) {
        filters = { [field]: value };
      }
    }

    if (filters) {
      this.addQueryParams(filters);
      this.refresh(filters);
    }
  }

  filterData() {
    return {
      employees: this.state.employees,
      startDate: this.state.filters.start_date,
      endDate: this.state.filters.end_date,
      timestamp: this.state.filters.solicitation_reporting_timestamp,
      selected: this.state.selected_employee,
    };
  }

  closeModal() {
    $('body').css('overflow', 'auto');
    this.setState({ isModalOpen: false, solicitationFilters: {} });
  }

  render() {
    let header =
      (this.state.loading && !this.state.employees) || this.state.error ? (
        <WidgetContainer title="" widget={widgets['EmptyFilters']} />
      ) : (
        <WidgetContainer
          title=""
          widget={widgets['HeaderFilters']}
          data={this.filterData()}
          handler={this.handleFilter}
        />
      );
    return (
      <div>
        <StellaLoading loading={this.state.isModalOpen} zIndex={9} />
        {header}
        <StellaLoading
          loading={this.state.loading || this.state.loadingSolicitations}
          loadingImage={this.props.loading_image}
        />
        <StellaError
          error={this.state.error}
          errorImage={this.props.error_image}
        />
        {this.loadedComponents()}
      </div>
    );
  }

  loadedComponents() {
    if (!this.state.loading && !this.state.error) {
      return (
        <div>
          <Headline
            employee={this.state.selected_employee}
            startDate={this.state.filters.start_date}
            endDate={this.state.filters.end_date}
          />
          {this.state.show_coaching_notes_widget && (
            <div className="member-trends-takeaways">
              <div className="actions-and-kudos-container">
                <ActionsAndKudos />
              </div>
            </div>
          )}
          <WidgetContainer
            title="Overview"
            widget={widgets['Overview']}
            data={this.state.overview}
          />
          {this.displayWidgets()}
        </div>
      );
    } else {
      return null;
    }
  }

  configureChart() {
    Chart.defaults.global.defaultFontFamily = `'Nunito', 'Helvetica Neue', Helvetica, Arial, sans-serif`;
    Chart.defaults.global.defaultFontSize = 14;
    Chart.defaults.global.tooltips.callbacks.footer = function () {
      return 'Click to see responses.';
    };
    Chart.defaults.global.defaultFontColor = '#77777C';
    Chart.defaults.global.legend.position = 'bottom';
    Chart.defaults.global.legend.labels.boxWidth = 16;
    Chart.defaults.global.legend.labels.padding = 20;
    Chart.defaults.global.hover.animationDuration = 400;
    Chart.defaults.global.tooltips.mode = 'index';
    Chart.defaults.global.tooltips.position = 'nearest';
    Chart.defaults.global.tooltips.cornerRadius = 0;
    Chart.defaults.global.tooltips.backgroundColor = 'rgba(0,0,0,.8)';
    Chart.defaults.global.tooltips.titleFontColor = '#ffffff';
    Chart.defaults.global.tooltips.bodyFontColor = '#ffffff';
    Chart.defaults.global.tooltips.footerFontColor = '#ffffff';
    Chart.defaults.global.tooltips.titleMarginBottom = 15;
    Chart.defaults.global.tooltips.caretSize = 10;
    Chart.defaults.global.tooltips.xPadding = 15;
    Chart.defaults.global.tooltips.yPadding = 15;
    Chart.defaults.global.elements.line.borderCapStyle = 'round';
    Chart.defaults.global.layout = {
      padding: { top: 10, right: 15, bottom: 10, left: 15 },
    };
    Chart.defaults.global.locale =
      (window.Localize && window.Localize.getLanguage()) || 'en';
  }
}

export default AgentTrends;
